import React, { forwardRef, useState } from "react";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../StyledComp/StyledComp";
import { useDispatch } from "react-redux";
import {
  updateMember_Sections,
  updateMember_Tags,
} from "../../store/memberApiSlice";
interface IMemberTags {
  Fee: number;
  Id: number;
  Description: string;
  MemberTag: string;
  isSelected: boolean;
  Status: boolean;
}

interface ISelectedMemberTag {
  Id: number | null;
  MemberTag: string | null;
  MemberId: number | null;
}

interface IProps {
  memberTag: IMemberTags;
  onChangeFunction: (
    event: React.ChangeEvent<HTMLInputElement>,
    memberTag: IMemberTags
  ) => void;
}

const MDEditTagsMultipleOptionItems: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  // const section = props.memberTag;
  // console.log("props.memberTag:", props.memberTag);
  const [checkboxIsSelected, setCheckboxIsSelected] = useState<boolean>(
    props.memberTag.isSelected
  );
  if (props.memberTag.Id === 4 && props.memberTag.isSelected) {
    // setCheckboxIsSelected(props.memberTag.isSelected);
    console.log(
      "memberTag4-1:",
      props.memberTag.isSelected,
      "-",
      checkboxIsSelected
    );
  }
  const handleChecked = (
    event: React.ChangeEvent<HTMLInputElement>,
    memberTag: IMemberTags
  ) => {
    if (memberTag.Id === 4) {
      console.log("memberTag4-2:", memberTag.isSelected);
    }
    setCheckboxIsSelected(!checkboxIsSelected);
    props.memberTag.isSelected = !props.memberTag.isSelected;
    props.onChangeFunction(event, memberTag);
  };

  return (
    <>
      <div key={props.memberTag.Id} className="checkboxgroup">
        <input
          id={String(props.memberTag.Id)}
          className="checkbox"
          type="checkbox"
          checked={checkboxIsSelected}
          onChange={(event) => handleChecked(event, props.memberTag)}
        />
        <div>
          <span>{props.memberTag.MemberTag}</span>
        </div>
      </div>
    </>
  );
};

export default MDEditTagsMultipleOptionItems;
